var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 34,
    viewBox: "0 0 118 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.956 34H4.34444C1.95609 34 0 32.0864 0 29.75V4.25C0 1.91357 1.95609 4.15896e-06 4.34444 4.15896e-06H112.956C115.344 4.15896e-06 117.3 1.91357 117.3 4.25V29.75C117.3 32.0864 115.344 34 112.956 34Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.956 0.681066C114.967 0.681066 116.604 2.28225 116.604 4.25V29.75C116.604 31.7178 114.967 33.3189 112.956 33.3189H4.34444C2.33297 33.3189 0.696197 31.7178 0.696197 29.75V4.25C0.696197 2.28225 2.33297 0.681066 4.34444 0.681066H112.956ZM112.956 4.15896e-06H4.34444C1.95609 4.15896e-06 0 1.91357 0 4.25V29.75C0 32.0864 1.95609 34 4.34444 34H112.956C115.344 34 117.3 32.0864 117.3 29.75V4.25C117.3 1.91357 115.344 4.15896e-06 112.956 4.15896e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2802 8.70702C41.2802 9.41677 41.0625 9.98521 40.6338 10.4091C40.1408 10.9117 39.4987 11.1646 38.7119 11.1646C37.9599 11.1646 37.3179 10.9075 36.7912 10.4006C36.2634 9.88639 36 9.25527 36 8.49983C36 7.7444 36.2634 7.11327 36.7912 6.60327C37.3179 6.09221 37.9599 5.83508 38.7119 5.83508C39.0863 5.83508 39.4432 5.91052 39.7838 6.05077C40.1234 6.19208 40.3998 6.38333 40.6 6.61921L40.1451 7.06758C39.7958 6.6649 39.3202 6.46621 38.7119 6.46621C38.1634 6.46621 37.6879 6.65321 37.2841 7.0304C36.8847 7.40865 36.6845 7.89846 36.6845 8.49983C36.6845 9.10121 36.8847 9.59527 37.2841 9.97352C37.6879 10.3465 38.1634 10.5377 38.7119 10.5377C39.2941 10.5377 39.7838 10.3465 40.1702 9.96927C40.4248 9.71958 40.5695 9.37533 40.6076 8.93546H38.7119V8.32133H41.241C41.2715 8.45415 41.2802 8.58271 41.2802 8.70702Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2904 6.57784H42.9147V8.19284H45.0564V8.80696H42.9147V10.422H45.2904V11.0478H42.2422V5.95203H45.2904V6.57784Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1219 11.0478H47.4493V6.57784H45.9922V5.95203H49.5801V6.57784H48.1219V11.0478Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1875 11.0478V5.95203H52.8589V11.0478H52.1875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.825 11.0478H55.1579V6.57784H53.6953V5.95203H57.2876V6.57784H55.825V11.0478Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0922 10.3921C63.5775 10.9075 62.9397 11.1646 62.1791 11.1646C61.414 11.1646 60.7763 10.9075 60.2616 10.3921C59.7479 9.8779 59.4922 9.24677 59.4922 8.49983C59.4922 7.7529 59.7479 7.12177 60.2616 6.60752C60.7763 6.09221 61.414 5.83508 62.1791 5.83508C62.9354 5.83508 63.5731 6.09221 64.0879 6.61177C64.6059 7.13027 64.8616 7.75715 64.8616 8.49983C64.8616 9.24677 64.6059 9.8779 64.0922 10.3921ZM60.7589 9.96502C61.1463 10.3465 61.6175 10.5377 62.1791 10.5377C62.7362 10.5377 63.2118 10.3465 63.5949 9.96502C63.9812 9.58358 64.1771 9.09377 64.1771 8.49983C64.1771 7.9059 63.9812 7.41608 63.5949 7.03465C63.2118 6.65321 62.7362 6.46196 62.1791 6.46196C61.6175 6.46196 61.1463 6.65321 60.7589 7.03465C60.3726 7.41608 60.1767 7.9059 60.1767 8.49983C60.1767 9.09377 60.3726 9.58358 60.7589 9.96502Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7969 11.0478V5.95203H66.6131L69.1508 9.91515H69.1802L69.1508 8.93552V5.95203H69.8223V11.0478H69.1215L66.464 6.88915H66.4346L66.464 7.87303V11.0478H65.7969Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3154 18.4896C57.2706 18.4896 55.6001 20.0089 55.6001 22.1053C55.6001 24.1846 57.2706 25.7199 59.3154 25.7199C61.3645 25.7199 63.035 24.1846 63.035 22.1053C63.035 20.0089 61.3645 18.4896 59.3154 18.4896ZM59.3154 24.2961C58.1934 24.2961 57.2281 23.3919 57.2281 22.1053C57.2281 20.8016 58.1934 19.9133 59.3154 19.9133C60.4373 19.9133 61.407 20.8016 61.407 22.1053C61.407 23.3919 60.4373 24.2961 59.3154 24.2961ZM51.209 18.4896C49.1599 18.4896 47.4938 20.0089 47.4938 22.1053C47.4938 24.1846 49.1599 25.7199 51.209 25.7199C53.2571 25.7199 54.9243 24.1846 54.9243 22.1053C54.9243 20.0089 53.2571 18.4896 51.209 18.4896ZM51.209 24.2961C50.086 24.2961 49.1174 23.3919 49.1174 22.1053C49.1174 20.8016 50.086 19.9133 51.209 19.9133C52.331 19.9133 53.2963 20.8016 53.2963 22.1053C53.2963 23.3919 52.331 24.2961 51.209 24.2961ZM41.5628 19.5978V21.1341H45.3205C45.2106 21.9926 44.9168 22.6238 44.4663 23.0636C43.9178 23.5949 43.0635 24.1846 41.5628 24.1846C39.2503 24.1846 37.4395 22.3624 37.4395 20.1046C37.4395 17.8468 39.2503 16.0246 41.5628 16.0246C42.8132 16.0246 43.723 16.5016 44.3944 17.12L45.5034 16.0373C44.5642 15.1618 43.3149 14.4893 41.5628 14.4893C38.3917 14.4893 35.7266 17.0085 35.7266 20.1046C35.7266 23.2007 38.3917 25.7199 41.5628 25.7199C43.2768 25.7199 44.5642 25.1716 45.5763 24.1431C46.6134 23.1306 46.9366 21.7068 46.9366 20.5572C46.9366 20.2002 46.9061 19.8719 46.8517 19.5978H41.5628ZM81.0074 20.7888C80.7016 19.9803 79.7581 18.4896 77.8362 18.4896C75.9318 18.4896 74.3462 19.9548 74.3462 22.1053C74.3462 24.1304 75.9155 25.7199 78.019 25.7199C79.72 25.7199 80.7016 24.7073 81.1053 24.1176L79.8429 23.2963C79.4218 23.8977 78.8483 24.2961 78.019 24.2961C77.1952 24.2961 76.6043 23.9274 76.2256 23.2007L81.1782 21.2L81.0074 20.7888ZM75.9579 21.9926C75.9155 20.5986 77.0668 19.8846 77.8917 19.8846C78.5381 19.8846 79.0866 20.2002 79.2694 20.6518L75.9579 21.9926ZM71.9325 25.4999H73.5605V14.8749H71.9325V25.4999ZM69.2663 19.2949H69.2119C68.8462 18.8721 68.1487 18.4896 67.265 18.4896C65.4106 18.4896 63.7151 20.0791 63.7151 22.1169C63.7151 24.1431 65.4106 25.7199 67.265 25.7199C68.1487 25.7199 68.8462 25.3342 69.2119 24.8986H69.2663V25.4171C69.2663 26.7994 68.51 27.5421 67.29 27.5421C66.2954 27.5421 65.6783 26.8408 65.4237 26.2511L64.0079 26.8281C64.416 27.7864 65.4966 28.9658 67.29 28.9658C69.1988 28.9658 70.8094 27.8693 70.8094 25.2014V18.7095H69.2663V19.2949ZM67.4043 24.2961C66.2823 24.2961 65.3432 23.3792 65.3432 22.1169C65.3432 20.843 66.2823 19.9133 67.4043 19.9133C68.51 19.9133 69.3816 20.843 69.3816 22.1169C69.3816 23.3792 68.51 24.2961 67.4043 24.2961ZM88.6294 14.8749H84.7357V25.4999H86.3594V21.4741H88.6294C90.4327 21.4741 92.2011 20.2002 92.2011 18.174C92.2011 16.1489 90.4283 14.8749 88.6294 14.8749ZM88.6719 19.9962H86.3594V16.3529H88.6719C89.8842 16.3529 90.5763 17.3357 90.5763 18.174C90.5763 18.9964 89.8842 19.9962 88.6719 19.9962ZM98.7088 18.4694C97.5356 18.4694 96.3157 18.9751 95.814 20.0961L97.2549 20.6858C97.565 20.0961 98.1353 19.9048 98.7381 19.9048C99.5804 19.9048 100.435 20.3989 100.448 21.2712V21.3828C100.154 21.217 99.5249 20.9716 98.7512 20.9716C97.1994 20.9716 95.6181 21.8056 95.6181 23.3622C95.6181 24.7859 96.8892 25.7029 98.3181 25.7029C99.4107 25.7029 100.014 25.2216 100.392 24.6616H100.448V25.4829H102.016V21.4072C102.016 19.5234 100.575 18.4694 98.7088 18.4694ZM98.5129 24.2919C97.9818 24.2919 97.2418 24.0348 97.2418 23.3919C97.2418 22.5696 98.1646 22.254 98.9634 22.254C99.6784 22.254 100.014 22.4081 100.448 22.611C100.32 23.5949 99.4531 24.2919 98.5129 24.2919ZM107.729 18.7021L105.863 23.308H105.807L103.878 18.7021H102.127L105.026 25.1387L103.372 28.7204H105.068L109.536 18.7021H107.729ZM93.0934 25.4999H94.7214V14.8749H93.0934V25.4999Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08343 6.40793C8.82769 6.66931 8.67969 7.07625 8.67969 7.60325V26.401C8.67969 26.928 8.82769 27.3349 9.08343 27.5963L9.14654 27.6537L19.9354 17.1243V16.8757L9.14654 6.34631L9.08343 6.40793Z",
    fill: "url(#paint0_linear_13148_55576)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.522 20.6359L19.9297 17.1243V16.8757L23.5263 13.3641L23.6069 13.4098L27.8663 15.776C29.0818 16.4475 29.0818 17.5525 27.8663 18.2282L23.6069 20.5902L23.522 20.6359Z",
    fill: "url(#paint1_linear_13148_55576)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6151 20.5902L19.9379 17L9.08594 27.5964C9.48968 28.0107 10.1481 28.0607 10.8968 27.6463L23.6151 20.5902Z",
    fill: "url(#paint2_linear_13148_55576)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6151 13.4098L10.8968 6.35375C10.1481 5.94363 9.48968 5.99356 9.08594 6.40794L19.9379 17L23.6151 13.4098Z",
    fill: "url(#paint3_linear_13148_55576)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13148_55576",
    x1: 18.9775,
    y1: 26.5968,
    x2: 4.71654,
    y2: 11.9902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13148_55576",
    x1: 29.4491,
    y1: 16.9988,
    x2: 8.3834,
    y2: 16.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13148_55576",
    x1: 21.6156,
    y1: 15.0484,
    x2: 2.27655,
    y2: -4.75926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13148_55576",
    x1: 6.35427,
    y1: 33.8502,
    x2: 14.99,
    y2: 25.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.1b6402c31cf8a981d44a7bccbcef9aa8.svg";
export { ForwardRef as ReactComponent };